<div [ngClass]="{'is-mobile': deviceSvc.isMobile}" class="wrapper">
  <div class="content">
    <div (pointerup)="expanded = !expanded"
         class="flag-wrapper">
      <img [alt]="i18nSvc.selLang?.code" [ngSrc]="'assets/img/flag/'+i18nSvc.selLang?.code+'.svg'" fill />
    </div>
  </div>
  @if (expanded) {
    <div class="close-overlay" (pointerup)="expanded=false"></div>
    <div class="selection-wrapper">
      @for (lang of i18nSvc.languages; track lang) {
        <div class="selection-item"
             (pointerup)="selectLanguage(lang)">
          <div class="flag-wrapper">
            <img alt="en-US" [ngSrc]="'assets/img/flag/' + lang.code + '.svg'" fill />
          </div>
          <div class="inter"
               [ngClass]="{'large': deviceSvc.isMobile, 'medium': !deviceSvc.isMobile}">
            {{ langNames[lang.code] }}
          </div>
        </div>
      }
    </div>
  }
</div>
